import React from 'react';
import dayjs from 'dayjs'
import Avatar from 'react-avatar';

export default class Card extends React.Component {

    goTo() {
        const { idea, history } = this.props;
        window.scrollTo(0, 0);
        history.push(`/ideas/${idea._id}`);
    }

    render() {
        const { idea, iLike } = this.props;
        const featureImg = Boolean(idea.featureImgUrl) ? idea.featureImgUrl : require('../../assets/default_bg.jpg');
        return (
            <div className="mx-auto lg:m-0 max-w-sm w-full sm:w-1/2 lg:w-1/3 py-6 px-3">
                <div className="bg-white shadow-xl rounded-lg overflow-hidden">
                    <div className="relative bg-cover bg-center h-56 p-4" style={{ backgroundImage: `url(${featureImg})` }}>
                        <div className="bg-west-green rounded p-2 circle relative inline-block">
                            {iLike() ?
                                <svg
                                    onClick={() => this.props.removeIdeaLike()}
                                    className="relative cursor-pointer h-6 w-6 text-red-600 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 4.248c-3.148-5.402-12-3.825-12 2.944 0 4.661 5.571 9.427 12 15.808 6.43-6.381 12-11.147 12-15.808 0-6.792-8.875-8.306-12-2.944z"/></svg>
                                :
                                <svg onClick={() => this.props.likeIdea()} className="relative cursor-pointer h-6 w-6 text-white fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                    <path d="M12.76 3.76a6 6 0 0 1 8.48 8.48l-8.53 8.54a1 1 0 0 1-1.42 0l-8.53-8.54a6 6 0 0 1 8.48-8.48l.76.75.76-.75zm7.07 7.07a4 4 0 1 0-5.66-5.66l-1.46 1.47a1 1 0 0 1-1.42 0L9.83 5.17a4 4 0 1 0-5.66 5.66L12 18.66l7.83-7.83z"></path>
                                </svg>
                            }
                        </div>
                    </div>
                    <div className="p-4 cursor-pointer" onClick={() => this.goTo()}>
                        <p className="text-2xl text-gray-900 truncate">{idea.title}</p>
                        <p className="truncate text-gray-700">{idea.content}</p>
                    </div>
                    <div className="px-4 pt-3 pb-4 border-t border-gray-300 bg-gray-100">
                        <div className="flex items-center pt-2">
                            <Avatar className="mr-4" size="50px" color="#80c7bc" round={true} name={`${idea.user.firstName} ${idea.user.lastName}`} />
                            <div>
                                <p className="font-bold text-gray-900">{Boolean(idea.user.firstName) ? `${idea.user.firstName} ${idea.user.lastName}` : 'Coworker'}</p>
                                <p className="text-sm text-gray-700">{dayjs(idea.createdAt).format('MMM DD, YYYY h:mma')}</p>
                                <p className="text-sm font-semibold text-gray-700">{idea.likes.length} like{idea.likes.length === 1 ? '' : 's'} <span className="font-normal"> | </span> {idea.comments.length} comment{idea.comments.length === 1 ? '' : 's'}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ideas/card.js